import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { getSystemConfig } from "../../../../application/selectors/auth";
import LogoIcon from "../../../assets/images/logo-icon.png";

const PanelInfo = ({ size = null, className, showName = false }) => {
  const { data: configs } = useSelector(getSystemConfig);

  const image = (
    <img
      src={configs?.logo ? configs.baseUrl + configs.logo : LogoIcon}
      alt={configs?.panelTitle || "یکسا"}
      className={className}
      {...(typeof size === "number"
        ? {
            width: size,
            height: size,
          }
        : {})}
    />
  );

  if (showName) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {image}
        {showName ? configs?.panelTitle || "Solarent" : null}
      </Box>
    );
  }

  return image;
};

export default PanelInfo;
